/**
 * Mobile nav drawer toggle + accordion sub-menus.
 */

/** Pomiar menu — GTM jest już na stronie, więc wystarczy dataLayer. */
function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event }, payload));
}

export function initMobileNav() {
    const drawer = document.getElementById('hn-mobile-drawer');
    if (!drawer) return;

    const toggles = document.querySelectorAll('[data-hn-mobile-toggle]');
    const closes = drawer.querySelectorAll('[data-hn-mobile-close]');

    toggles.forEach((btn) => {
        btn.addEventListener('click', () => {
            if (typeof drawer.showModal === 'function') {
                drawer.showModal();
                btn.setAttribute('aria-expanded', 'true');
            } else {
                drawer.setAttribute('open', '');
            }
            // showModal() nie blokuje przewijania tła — bez tego na mobile widać
            // dwa paski przewijania naraz.
            document.documentElement.classList.add('hn-drawer-open');
            track('hn_menu_open', { menu_location: 'mobile_drawer' });
        });
    });

    closes.forEach((btn) => {
        btn.addEventListener('click', () => drawer.close());
    });

    drawer.addEventListener('click', (e) => {
        if (e.target === drawer) drawer.close();
    });

    drawer.addEventListener('close', () => {
        toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        document.documentElement.classList.remove('hn-drawer-open');
    });

    // Accordion sub-menus — collapse all on open, allow toggle.
    const itemsWithChildren = drawer.querySelectorAll('.hn-mobile-menu .menu-item-has-children');
    itemsWithChildren.forEach((item) => {
        item.classList.add('hn-mobile-menu__item--collapsible');
        const link = item.querySelector(':scope > a');
        if (!link) return;
        // Insert toggle button next to link (keep link href working — toggle is separate).
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'hn-mobile-menu__toggle';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', `Rozwiń podmenu: ${(link.textContent || '').trim()}`);
        toggle.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
        link.insertAdjacentElement('afterend', toggle);

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            const expanded = toggle.getAttribute('aria-expanded') === 'true';
            // Akordeon wyłączny — bez tego rozwinięcia kumulowały się do ~4 ekranów.
            if (!expanded) {
                itemsWithChildren.forEach((other) => {
                    if (other === item || !other.classList.contains('is-open')) return;
                    other.classList.remove('is-open');
                    const otherToggle = other.querySelector(':scope > .hn-mobile-menu__toggle');
                    if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
                });
            }
            toggle.setAttribute('aria-expanded', String(!expanded));
            item.classList.toggle('is-open', !expanded);
            if (!expanded) {
                track('hn_menu_expand', { menu_category: (link.textContent || '').trim() });
            }
        });
    });

    // Klik w pozycję menu — wiemy, co ludzie faktycznie wybierają.
    drawer.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link || !drawer.contains(link)) return;
        let level = 'top';
        // Kafelki akcji mają etykietę w atrybucie — textContent zawiera też opis.
        let label = link.getAttribute('data-hn-drawer-action');
        if (label) level = 'action';
        else if (link.closest('.sub-menu')) level = 'sub';
        track('hn_menu_click', {
            menu_label: (label || link.textContent || '').trim().slice(0, 80),
            menu_level: level,
            menu_href: link.getAttribute('href') || '',
        });
    });

    // Koszyk w szufladzie: zamknij menu i otwórz side cart. Bez JS link prowadzi
    // do /koszyk/, a side cart żyje poza <dialog>, więc przy showModal() byłby
    // nieklikalny — stąd najpierw close(), dopiero potem otwarcie.
    const drawerCart = drawer.querySelector('[data-hn-drawer-cart]');
    if (drawerCart) {
        drawerCart.addEventListener('click', (e) => {
            const sideCartToggle = document.querySelector('[data-hn-cart-toggle]');
            if (!sideCartToggle) return; // brak side cart → zwykła nawigacja do /koszyk/
            e.preventDefault();
            drawer.close();
            sideCartToggle.click();
        });
    }

    // Account section accordion — "Moje konto" z chevronem toggle'uje sub-linki
    // (zamówienia, subskrypcje, adresy...). Link konta nadal nawiguje do /moje-konto,
    // chevron jest osobnym przyciskiem — ten sam pattern co menu sub-items wyżej.
    const accountWrap = drawer.querySelector('.hn-header__account-wrap');
    if (accountWrap) {
        const accountLink = accountWrap.querySelector('.hn-header__account');
        const accountDropdown = accountWrap.querySelector('.hn-header__account-dropdown');
        if (accountLink && accountDropdown) {
            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'hn-mobile-menu__toggle';
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', 'Rozwiń menu konta');
            toggle.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
            accountLink.insertAdjacentElement('afterend', toggle);

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const expanded = toggle.getAttribute('aria-expanded') === 'true';
                toggle.setAttribute('aria-expanded', String(!expanded));
                accountWrap.classList.toggle('is-open', !expanded);
            });
        }
    }
}

/**
 * Menu na desktopie: przycisk przy kategorii rozwija podmenu (aria-expanded), Esc zamyka (WCAG 1.4.13, 4.1.2).
 */
export function initDesktopMenu() {
    const toggles = document.querySelectorAll('.hn-menu .hn-menu__toggle');
    if (!toggles.length) return;

    const setExpanded = (btn, open) => btn.setAttribute('aria-expanded', String(open));
    const closeAll = (except) => toggles.forEach((b) => { if (b !== except) setExpanded(b, false); });

    toggles.forEach((btn) => {
        const item = btn.closest('li');
        btn.addEventListener('click', () => {
            const open = btn.getAttribute('aria-expanded') !== 'true';
            closeAll(btn);
            setExpanded(btn, open);
            item.classList.remove('is-dismissed');
        });
        item.addEventListener('focusout', (e) => {
            if (!item.contains(e.relatedTarget)) setExpanded(btn, false);
        });
        item.addEventListener('mouseleave', () => item.classList.remove('is-dismissed'));
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const open = [...toggles].find((b) => b.getAttribute('aria-expanded') === 'true');
        if (open) {
            setExpanded(open, false);
            open.focus();
        }
        document.querySelectorAll('.hn-menu > li:hover').forEach((li) => li.classList.add('is-dismissed'));
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.hn-menu')) closeAll();
    });
}
